var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 42,
    viewBox: "0 0 42 42",
    width: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m34.125 8.75h-26.25c-2.41625 0-4.375 1.9588-4.375 4.375v1.75h35v-1.75c0-2.4162-1.9588-4.375-4.375-4.375zm-30.625 20.125v-10.1719h35v10.1719c0 2.4162-1.9588 4.375-4.375 4.375h-26.25c-2.41625 0-4.375-1.9588-4.375-4.375zm4.05713-6.3438h4.61367c.4832 0 .875.3918.875.875v2.8438c0 .4832-.3918.875-.875.875h-4.61367c-.48325 0-.875-.3918-.875-.875v-2.8438c0-.4832.39175-.875.875-.875z",
    fill: "#afafaf",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCard);
export default __webpack_public_path__ + "static/media/grey-card.6bd89be6a371f7fd149ff5962340e315.svg";
export { ForwardRef as ReactComponent };